import { Badge as AntdBadge, Flex } from 'antd';

type BadgeProps = {
  count: number;
};

export const Badge: React.FC<BadgeProps> = ({ count }) => {
  return (
    <Flex align="center" justify="center">
      <AntdBadge count={count} />
    </Flex>
  );
};
